export const API_URL = 'https://hweb8d13gj.execute-api.eu-west-1.amazonaws.com/prod';

export const COGNITO = {
  userPoolId: 'eu-west-1_RpxESHoPp',
  clientId: '57ia4o88o90kfndfa0s9atgjvb',
  region: 'eu-west-1',
} as const;

export const LANDING_URL = 'https://myfootballjournal.com';
export const PRIVACY_URL = `${LANDING_URL}/privacy`;
export const TERMS_URL = `${LANDING_URL}/terms`;
export const SUB_PROCESSORS_URL = `${LANDING_URL}/sub-processors`;
